import { useState, useRef } from "preact/hooks";
import { createContext } from "preact/compat";

export const GlobalContext = createContext();

export const GlobalContextProvider = (props) => {
    const [cartItemCount, setCartItemCount] = useState(0);
	const [checkout, setCheckout] = useState({});
	const [sideCartOpen, setSideCartOpen] = useState(false);
    const [locationSelectorOpen, setLocationSelectorOpen] = useState(false);
    const [modalProduct, setModalProduct] = useState({});
    const modalRef = useRef(null);
    const [sidebarEffects, setSidebarEffects] = useState([]);

    return (
        <GlobalContext.Provider value={{
            cartItemCount,
            setCartItemCount,
            checkout,
            setCheckout,
            sideCartOpen,
            setSideCartOpen,
            locationSelectorOpen,
            setLocationSelectorOpen,
            modalProduct,
            setModalProduct,
            modalRef,
            sidebarEffects,
            setSidebarEffects
        }}>
            {props.children}
        </GlobalContext.Provider>
    )
}